//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/RoutingCommon.js";
import "../no/Builder.js";
import "../Display/Display.LayerSettingsBuilder.js";
import "../no/Display.js";
let d=[[[1,"LayerSettings",0,"Display.LayerSettingsBuilder",0]],[[[],"GetAllowCutElbows",{R_:{allowCutElbows:''}},0,0],[["allowCutElbows"],"SetAllowCutElbows",{},1,0],[[],"GetReferenceSet",{R_:{referenceSet:''}},0,0],[["referenceSet"],"SetReferenceSet",{},1,0],[["nodeIdentifier"],"SetReuseNode",{},1,0]],[]];
SPLM.RoutingCommon.ElbowCornerOptionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.RoutingCommon.ElbowCornerOptionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.RoutingCommon.ElbowCornerOptionBuilder.ReferenceSetType = Object.freeze({
    "Model" : "Model", "EntirePart" : "EntirePart", "Empty" : "Empty"});

export default SPLM;